<template>
  <!-- `title` also goes to UModal: with a custom #content it renders a visually hidden
       dialog title for screen readers, so the visible heading below is aria-hidden. -->
  <UModal v-model:open="open" :title="title" :ui="{ content: wide === 'full' ? 'max-w-[min(95vw,1200px)]' : wide ? 'max-w-3xl' : 'max-w-[480px]' }">
    <template #content>
      <div class="dialog">
        <div class="dialog-title display" aria-hidden="true">{{ title }}</div>
        <slot />
        <div v-if="$slots.footer" class="dialog-footer">
          <slot name="footer" />
        </div>
      </div>
    </template>
  </UModal>
</template>

<script setup lang="ts">
// The one dialog shell: a title, a body, and a right-aligned row of actions.
// Styles are the .dialog rules in assets/css/main.css.
const open = defineModel<boolean>('open', { default: false })

// `wide` is a 768px dialog. 'full' takes most of the window, for side-by-side content.
defineProps<{ title: string; wide?: boolean | 'full' }>()
</script>
